<div tappable (click)="itemSelect.emit()">
  <ion-item [disabled]="disabled">
    <!--                    <ion-icon slot="start" [src]="UtilService.FileIcon(item.documentFileName)"></ion-icon>-->

    <div class="col-two text-style-2">
      <ion-img *ngIf="icon" slot="start" [src]="icon"></ion-img>
      <ion-text *ngIf="colFirst" class="text-style-1">{{ colFirst }}</ion-text>
    </div>

    <ion-text *ngIf="colSecondHighlighted" class="col-two text-style-2">
      <span class="label-for-highlight-text">{{ colSecond }}</span>
      <span class="highlight">{{ colSecondHighlighted }}</span>
    </ion-text>

    <ion-text *ngIf="colThirdHighlighted" class="col-three text-style-2">
      <span class="label-for-highlight-text">{{ colThird }}</span>
      <span class="highlight">{{ colThirdHighlighted }}</span>
    </ion-text>

    <ion-text *ngIf="colForthHighlighted" class="col-four text-style-2">
      <span class="label-for-highlight-text">{{ colForth }}</span>
      <span class="highlight">{{ colForthHighlighted }}</span>
    </ion-text>

    <ion-text *ngIf="colFifthHighlighted" class="col-five text-style-2">
      <span class="label-for-highlight-text">{{ colFifth }}</span>
      <span class="highlight">{{ colFifthHighlighted }}</span>
    </ion-text>

    <div (click)="fetchAndOpenDocument(colSixthHighlighted)" *ngIf="colSixthHighlighted" class="col-three text-style-2">
      <ion-icon slot="start" src="./assets/icon/attachment2.svg" class="custom-pdf-icon"></ion-icon>
      <span class="label-for-highlight-text">{{ colSixth }}</span>
    </div>
  </ion-item>
</div>
